export const GET_CANCEL_ORDER_ITEMS_REQUEST = 'GET_CANCEL_ORDER_ITEMS_REQUEST';
export const GET_CANCEL_ORDER_ITEMS_SUCCESS = 'GET_CANCEL_ORDER_ITEMS_SUCCESS';
export const GET_CANCEL_ORDER_ITEMS_ERROR = 'GET_CANCEL_ORDER_ITEMS_ERROR';
export const SHOW_CANCEL_ORDER_SLIDER = 'SHOW_CANCEL_ORDER_SLLDER';
export const HIDE_CANCEL_ORDER_SLIDER = 'HIDE_CANCEL_ORDER_SLIDER';
export const CANCEL_ORDER_SUBMIT_REQUEST = 'CANCEL_ORDER_SUBMIT_REQUEST';
export const CANCEL_ORDER_SUBMIT_SUCCESS = 'CANCEL_ORDER_SUBMIT_SUCCESS';
export const CANCEL_ORDER_SUBMIT_ERROR = 'CANCEL_ORDER_SUBMIT_ERROR';
export const RESOLVE_ORDER_ON_HOLD_REQUEST = 'RESOLVE_ORDER_ON_HOLD_REQUEST';
export const RESOLVE_ORDER_ON_HOLD_SUCCESS = 'RESOLVE_ORDER_ON_HOLD_SUCCESS';
export const RESOLVE_ORDER_ON_HOLD_ERROR = 'RESOLVE_ORDER_ON_HOLD_ERROR';
export const HIDE_CANCEL_ORDER_NOTIFICATION = 'HIDE_CANCEL_ORDER_NOTIFICATION';
export const SET_CANCEL_ORDER_ANALYTICS_DATA = 'SET_CANCEL_ORDER_ANALYTICS_DATA';
export const TRACK_CANCEL_ORDER_SUBMIT_SUCCESS = 'TRACK_CANCEL_ORDER_SUBMIT_SUCCESS';
export const TRACK_CANCEL_ORDER_SLIDER_ON_LOAD = 'TRACK_CANCEL_ORDER_SLIDER_ON_LOAD';
export const TRACK_CANCEL_ORDER_SLIDER_ON_LOAD_ERROR = 'TRACK_CANCEL_ORDER_SLIDER_ON_LOAD_ERROR';
export const UNMOUNT_CANCEL_ORDER_SLIDER = 'UNMOUNT_CANCEL_ORDER_SLIDER';
